export default __webpack_public_path__ + "static/media/nft-1.249a509b.png";